import React from 'react'
import { Map } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { useMutation } from '@apollo/client'
import { getBoundActions } from '../../../actions/index'
import { createTitleGroupId } from '../../../services/content/index'
import { TYPE_CONTENT_COURSE } from '../../../services/content-type/index'
import { getAuthIsLoggedIn } from '../../../services/auth/index'
import {
  USER_STATE_PROGRESS_ITEM_TYPE_ASSET,
  COURSE_STATE_COMPLETE,
  COURSE_STATE_IN_PROGRESS,
} from '../../../services/detail/index'
import { USER_STATE_CREATE_OR_UPDATE } from '../../../services/detail/query'
import Button, { TYPES } from '../../Button/index'
import CheckIcon from '../../Icon/icons/Check/index'
import ReplayIcon from '../../Icon/icons/Replay/index'
import Link, { TARGET_BLANK } from '../../Link/index'
import FilePdfIcon from '../../Icon/icons/FilePdf/index'

/**
 * @param {Object} props - The props
 * @param {Map} props.auth - The auth data
 * @param {Map} props.asset - The course module asset data
 * @param {number} props.courseContentId - The course content ID
 * @param {function} props.onCourseStateChange - The function to handle course state change
 * @param {Map} props.staticText - The static text data
 * @returns {JSX.Element} DetailPageV3CourseModuleAsset
 */

const DetailPageV3CourseModuleAsset = (props) => {
  const {
    auth,
    asset = Map(),
    courseContentId,
    onCourseStateChange,
    staticText,
  } = props

  const jwt = auth.get('jwt')
  const isLoggedIn = getAuthIsLoggedIn(auth)
  const completed = asset.getIn(['courseItemProgress', 'state']) === COURSE_STATE_COMPLETE
  const assetId = asset.get('uuid')

  const [userStateCreateOrUpdate, { loading }] = useMutation(USER_STATE_CREATE_OR_UPDATE, {
    variables: {
      progressItemType: USER_STATE_PROGRESS_ITEM_TYPE_ASSET,
      progressItemId: assetId,
      parentContentTitleGroupId: createTitleGroupId(courseContentId, TYPE_CONTENT_COURSE),
      state: completed ? COURSE_STATE_IN_PROGRESS : COURSE_STATE_COMPLETE,
    },
    context: {
      jwt,
    },
  })

  const handleStateChange = async () => {
    await userStateCreateOrUpdate()
    onCourseStateChange()
  }

  const className = [
    'detail-page-v3__course-module-asset',
    completed ? 'detail-page-v3__course-module-asset--completed' : '',
  ].filter((cls) => !!cls).join(' ')

  return (
    <div className={className}>
      <Link to={asset.get('renderUrl')} target={TARGET_BLANK} className="detail-page-v3__course-module-asset-link">
        <FilePdfIcon color="#B03874" size={24}/>
        <span>{asset.get('originalFileName')}</span>
      </Link>
      {!!assetId && isLoggedIn && (
        <Button
          className="detail-page-v3__course-module-asset-button"
          type={TYPES.GHOST}
          onClick={handleStateChange}
          disabled={loading}
        >
          {completed ? <ReplayIcon size={20} /> : <CheckIcon size={20} />}
          {' '}
          <span>
            {completed ? staticText.get('startAgain') : staticText.get('markAsComplete')}
          </span>
        </Button>
      )}
    </div>
  )
}

export default connectRedux((state) => ({
  auth: state.auth,
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3CourseModuleAsset)
